// extracted by mini-css-extract-plugin
export default {"Breadcrumbs":"RolesToolbar_Breadcrumbs__XdgLe","BreadcrumbsLoadingSpinner":"RolesToolbar_BreadcrumbsLoadingSpinner__z77tS","Toolbar":"RolesToolbar_Toolbar__ThSRn"};